export class OrderResponseModel {
    consumer: Consumer = new Consumer();
    documents: DocumentsEntity[] = new Array<DocumentsEntity>();
    invoice: Invoice = new Invoice();
    kycDetails: KycDetails = new KycDetails();
    orderCreateDate: string;
    orderId: string;
    colorStatus: string;
    orderItems: OrderItemsEntity[] = new Array<OrderItemsEntity>();
    orderStatusGroup: OrderStatusGroup = new OrderStatusGroup();
    orderFeedback: OrderFeedback = new OrderFeedback();
    beneficiaryDetails = new BeneficiaryDetails();
    beneficiaryDetailsMap = new Array<beneficiaryDetailsMap>();
    remittanceStatusDetails = new remittanceStatusDetails();
    partner = new PartnerModel();
    payerType: string;
    sellType: string;
    applicationId: any;
    orderType: string;
    productGroup: string;
    pax: Pax = new Pax();
    delivery: Delivery = new Delivery();
    userId: string;
    extInvoice: string;
    extSwift: string;
    a2Form: string;
    awbNumber: string;
    deliveryStatus: string;
    wsflReferenceBranchId: string;
    branchName: string;
    amlCheck: boolean;
    travellingCountryName: any;
    fatfOfacEddCheck: boolean;
    applimitCheck: boolean;
    lrsLimitCheck: boolean;
    cashPaymentNotAllowed: boolean;
    tcslimitCheck: boolean;
    digitalDocumentsUploads: boolean;
    a2FormAadharEsignCheck: boolean;
    bankAccountverrificationCheck: boolean;
    transferMode: boolean;
    remittanceStatus: any;
    profileComplete: boolean;
    consumerProfileStatus: string;
    verifiedPan: boolean;
    vcipKycStatus: boolean;
    vcipSkipAllowed: boolean;
    caseId: string;
    flatDiscountString: any;
    discountOnServiceChargesString: any;
    rateDiscountString: any;
    totalDiscount: any;
    ieStatus: string;
    cfoId: string;
    dealId: any;
    rate: any;
    notstoChargesString: any;
    tcs: any;
    uiChannel: any;
    branchId: any;
    partnerId: any;
    creationType: string;
    travellingCountry: string;
    arrivalDate: any;
    departureDate: any;
    passportExpiryDate: any;
    passportIssueDate: any;
    passportIssuePlace: any;
    passportNumber: string;
    orderPortal: string;
    address: string;
    deliveryAddressType: string;
    applicationForm: string;
}
export class beneficiaryDetailsMap { }
export class remittanceStatusDetails {
    remittanceStatus: string;
    status1: string;
    transferMode: string;
    value1: string;
    status2: string;
    value2: string;
}

export class PartnerModel {
    address: string;
    alias: string;
    country: string;
    email: string;
    gstNumber: string;
    id: string;
    city: string;
    mobile: string;
    name: string;
    state: string;
    panNumber: string;
    partnerStatus: string;
    partnerType: string;
    photo: string;
    pinCode: string;
    userFirstName: string;
    userLastName: string;
    wsflPrimaryBranchId: string;
    wsflRelationshipManagerId: string;
    thirdPartyPartnerId: number;
}
export class Pax {
    consumerId: string;
    name: string;
    mobile: string;
    dob: string;
    email: string;
    nationality: string;
    ddInFavourOf: string;
    ddReferenceNumber: string;
    residentStatus: string;
    occupation: string;
    address: string;
    id: string;
    type: string;
    countryCode: string;
    passportNumber: string;
    surname: string;
    givenName: string;
    gender: string;
    dateOfBirth: string;
    placeOfBirth: string;
    photo: string;
    signature: string;
    otherId: string;
    passportIssueDate: any;
    passportExpiryDate: any;
    passportIssuePlace: string;
    ticketNumber: string;
    departureDate: string;
    arrivalDate: string;
    visitingCountry: string;
    numberOfDays: number;
    pan: string;
    cardDeliveryAddress: string;
    cardDeliveryTime: string;
    deliveryAddressType: string;
    cardDeliveryDate: string;
    cardDeliveryBranch: any;
    relationship: string;
}

export class Delivery {
    address: string;
    deliveryAddressType: string;
}
export class Consumer {
    address: string;
    consumerCreator: string;
    createdAt: string;
    dob: string;
    statusConsumerKyc: string;
    email: string;
    emailVerificationStatus: string;
    gender: string;
    id: string;
    mobile: string;
    name: string;
    firstName: string;
    lastName: string;
    photo: string;
    updatedAt: string;
    passportExpiryDate: any;
    passportIssueDate: any;
    passportIssuePlace: any;
    passport: any;
}
export class DocumentsEntity {
    id: string;
    type: string;
    createdAt: string;
    documentId: string;
    documentType: string;
    location: string;
    status: string;
    updatedAt: string;
    description: string;
    kycDocumentPurpose: string;
}
export class Invoice {
    [x: string]: any;
    beneficiaryCharges: number;
    billableAmount: number;
    cancellationFees: number;
    charges: Charges;
    convenienceFees: number;
    id: string;
    invoiceItems?: InvoiceItemsEntity[] | null;
    taxes: Taxes;
    totalBillAmount: number;
    totalHandlingCharges: number;
    totalPaymentReceived: number;
    totalTaxes: number;
    transactionFees: number;
}
export class Charges {
    beneficiaryCharges: number;
    convenienceFees: number;
    transactionFees: number;
}
export class InvoiceItemsEntity {
    beneficiaryCharges: number;
    cardRate: number;
    couponDiscount: number;
    currencyAmount: number;
    currencyCode: string;
    effectiveRate: number;
    orderItemId: string;
    partnerCommission: number;
    partnerDiscount: number;
    product: string;
    totalHandlingCharges: number;
    transactionFees: number;
    nostroCharges: number;
}
export class Taxes {
    cgst: number;
    igst: number;
    sgst: number;
    ugst: number;
}
export class KycDetails {
    address: string;
    dob: string;
    email: string;
    kycMedium: string;
    kycMode: string;
    mobile: string;
    name: string;
    status: string;
}
export class OrderItemsEntity {
    adminRate: number;
    beneficiaryDetails: BeneficiaryDetails;
    bidRate: number;
    countryCode: string;
    creator: string;
    creatorName: string;
    currencyAmount: number;
    currencyCode: string;
    id: string;
    orderItemId: string;
    partialPaymentBookingRate: number;
    product: string;
    purpose: string;
    partnerCommission: number;
    amountINR: number;
    fxcardOrder: FxCardOrder;
    cashOrder: CashOrder;
    remittanceOrder: RemittanceOrder;
    customIbr: any;
    issuerCode?: string;
}
export class BeneficiaryDetails {
    consumerId: string;
    address: string;
    bankAccountNumber: string;
    bankAddress: string;
    bankName: string;
    countryCode: string;
    createdAt: string;
    id: string;
    name: string;
    sortCode: string;
    swiftCode: string;
    updatedAt: string;
    additionalDetails: string;
    amlCheck: boolean;
    approvedBeneficiary: boolean;
    studentId: any;
    flyWireReferenceNumber: any;
}

export class CashOrder {
    passengerName: string;
    passengerAddress: string;
    travelStartDate: string;
    travelEndDate: string;
}

export class RemittanceOrder {
    createdAt: string;
    studentName: string;
    studentPayFeesType: string;
    studentReferenceNo: string;
    updatedAt: string;
}

export class FxCardOrder {
    createdAt: string;
    passengerAddress: string;
    passengerName: string;
    travelEndDate: string;
    travelStartDate: string;
    updatedAt: string;
}
export class OrderFeedback {
    onboarding: number;
    overall: number;
    support: number;
    transaction: number;
    transparency: number;
}
export class OrderStatusGroup {
    a2Form: string;
    consumerBeneficiaryDetails: string;
    consumerComplianceStatus: string;
    consumerKyc: string;
    consumerPayment: string;
    consumerSwift: string;
    status: string;
    wsflBeneficiaryDetails: string;
    wsflComplianceStatus: string;
    wsflKyc: string;
    wsflPayment: string;
    wsflSwift: string;
    statusConsumerKyc: any;
}

export class SwiftResponseModel {
    consumerId: string;
    createdAt: string;
    emailDetailsId: string;
    id: string;
    orderId: string;
    refNumber: string;
    swiftLocation: string;
    updatedAt: string;
}
export class TimerExpiryRateModel {
    wsfxMargin: number;
    agentMargin: number;
    bidRatePrevious: number;
    quotationBidRate: number;
    minRate: number;
    currency: string;
    product: string;
}

export class virualAccountModel {
    vAccountId: string;
    virtualAccountNumber: string;
    name: string;
    phone: Number;
    email: string;
    remitterAccount: string;
    remitterIfsc: string;
    status: string;
    minAmount: number;
    maxAmount: number;
    ifsc: string;
}

export class CredilaOrderResponse {
    id: string;
    abaRouteNoOfIntermediaryBank: string;
    additionalInformation: string;
    appId: string;
    arrivalDate: any;
    beneType: string;
    beneficiaryAccountNumber: string;
    beneficiaryAddress: string;
    beneficiaryBankAddress: string;
    beneficiaryBankCountry: string;
    beneficiaryBankName: string;
    beneficiaryCity: string;
    beneficiaryCountry: string;
    beneficiaryName: string;
    beneficiaryState: string;
    beneficiaryStreetName: string;
    beneficiaryStreetNo: string;
    beneficiaryTown: string;
    branchLocation: string;
    bsbCode: any;
    caseId: any;
    chargeCode: any;
    coApplicantAddressAsPerPassport: string;
    coApplicantCity: string;
    coApplicantCountry: string;
    coApplicantCurrentHouseNo: string;
    coApplicantCurrentLocality: string;
    coApplicantCurrentPinCode: string;
    coApplicantCurrentStreet: string;
    coApplicantDob: string;
    coApplicantEmail: string;
    coApplicantFirstName: string;
    coApplicantGender: string;
    coApplicantLastName: string;
    coApplicantMiddleName: string;
    coApplicantMobileNo: string;
    coApplicantNationality: string;
    coApplicantOccupation: string;
    coApplicantPan: string;
    coApplicantPassport: string;
    coApplicantPassportExpiryDate: string;
    coApplicantPassportIssueDate: string;
    coApplicantPassportPlaceOfIssue: string;
    coApplicantResidentStatus: string;
    coApplicantState: string;
    coApplicantTitle: string;
    comment: string;
    countryOfStudy: string;
    createdAt: any;
    createdAtIST: any;
    creator: {
        id: string;
        type: string;
    };
    currencyType: string;
    dealRefNo: string;
    departureDate: any;
    exchangeRate: string;
    fxAmount: string;
    gst: string;
    iban: string;
    ibr: string;
    intermediaryBankAddress: string;
    intermediaryBankBIC: string;
    intermediaryBankName: string;
    intermediaryBankSwiftCode: string;
    internationalSwiftCode: string;
    isRemitterStudent: string;
    issuerCode: string;
    loanAmount: string;
    modifier: {
        id: string;
        type: string;
    };
    nostroChargesInInr: string;
    orderId: string;
    paidBy: string;
    product: string;
    purpose: string;
    relationName: string;
    relationship: string;
    remittanceBy: string;
    routingNo: string;
    serviceCharges: string;
    sortCode: string;
    sourceOfFunds: string;
    financialInstitution: string;
    studentAddressAsPerPassport: string;
    studentCity: string;
    studentCountry: string;
    studentCurrentHouseNo: string;
    studentCurrentLocality: string;
    studentCurrentPinCode: string;
    studentCurrentStreet: string;
    studentDob: any;
    studentEmail: string;
    studentFirstName: string;
    studentGender: string;
    studentLastName: string;
    studentMiddleName: string;
    studentMobile: string;
    studentNationality: string;
    studentOccupation: string;
    studentPan: string;
    studentPassport: string;
    studentPassportExpiryDate: any;
    studentPassportIssueDate: any;
    studentPassportPlaceOfIssue: string;
    studentResidentStatus: string;
    studentState: string;
    studentTitle: string;
    order: OrderResponseModel = new OrderResponseModel();
}



// WEBPACK FOOTER //
// ./src/app/_models/order/OrderResponseModel.ts